var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4375 9.375H22.5625V0H9.4375V9.375ZM11.3125 7.5V1.875H20.6875V7.5H11.3125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.625 3.75H10.375V5.625H21.625V3.75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6875 32H26.3125V23.5625C26.3125 20.9737 24.2138 18.875 21.625 18.875H18.8125V18.2409C20.8159 17.2741 22.2429 15.2616 22.5152 12.9812C23.6322 12.6088 24.4375 11.5547 24.4375 10.3125C24.4375 8.75915 23.1783 7.49998 21.625 7.49998V9.37498C22.1428 9.37498 22.5625 9.79469 22.5625 10.3125C22.5625 10.8303 22.1428 11.25 21.625 11.25H20.6875V12.1875C20.6875 14.251 19.3618 16.0976 17.5626 16.7335L16.9375 16.9544V20.75H21.625C23.1783 20.75 24.4375 22.0092 24.4375 23.5625V30.125H7.5625V23.5625C7.5625 22.0092 8.8217 20.75 10.375 20.75H15.0625V16.9544L14.4374 16.7335C12.6382 16.0976 11.3125 14.251 11.3125 12.1875V11.25H10.375C9.8572 11.25 9.4375 10.8303 9.4375 10.3125C9.4375 9.79469 9.8572 9.37498 10.375 9.37498V7.49998C8.82167 7.49998 7.5625 8.75915 7.5625 10.3125C7.5625 11.5547 8.36776 12.6088 9.48477 12.9812C9.75712 15.2616 11.1841 17.2741 13.1875 18.2409V18.875H10.375C7.78617 18.875 5.6875 20.9737 5.6875 23.5625V32Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 25.6588L18.7135 20.2318L17.0365 19.3932L16 21.4662L14.9635 19.3932L13.2865 20.2318L16 25.6588Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0625 23.5625V31.0625H16.9375V23.5625H15.0625Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3125 31.0625V19.8125H9.4375V31.0625H11.3125Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6875 19.8125V31.0625H22.5625V19.8125H20.6875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValet);
export default __webpack_public_path__ + "static/media/Valet.f601ec603a22054c83107c958c7c6f25.svg";
export { ForwardRef as ReactComponent };